module.exports = __webpack_public_path__ + "static/media/benefit-2.287690bb.svg";